import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { mediaSettleStatistics } from 'lib/api/media';

import MbTooltip from 'components/atoms/MbTooltip';
import MbButton from 'components/atoms/MbButton';
import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
let initParam = {};
const Statistics = () => {
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const dispatch = useDispatch();

  const { t } = useTranslation();
  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'ADVRTS_AMT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              advrtsAmt.type,
              advrtsAmt.format
            )}
          </>
        );
      },
    },
    TRGT_ADVRTS_AMT: {
      merged: true,
    },
  };

  //   화면에서 추가될 컬럼
  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'LINK_ICONS',
      label: t('정산 히스토리'),
      align: 'center',
      makeRowFunc: (data) => {
        const showWindowUrl =
          '/report/mediasettle/mcount/history?mediaId=' +
          data['MEDIA_ID'] +
          '&uri=/report/mediasettle/mcount/history&isPop=1';
        return (
          <TableBtnWrap>
            {data.MEDIA_NAME !== 'total' && (
              <MbTooltip
                title={t('단기변경이력관리로 이동')}
                onClick={(e) => handlePortalUrl(showWindowUrl)}
              >
                <MbButton iconBtn icon={'faExternalLink'} />
              </MbTooltip>
            )}
          </TableBtnWrap>
        );
      },
    });
    return result;
  })();

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          initData={initParam}
          getParam={getParam}
          nonePltfomTpCodeFilter={true}
          nonePltfomTpCode={true}
          noneExternalFilter={true}
          noneDisplayFilter={true}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={mediaSettleStatistics}
            params={{ ...params }}
            sort="desc"
            order="ADVRTS_AMT"
            dense={true}
            customized={customized}
            addColumnList={addColumnList}
            hasExcel
            hasTotal
          />
        </>
      )}
    </>
  );
};

export default Statistics;
